import gql from 'graphql-tag';

const STOCK_DELIVERY_ITEM_DETAIL_FRAGMENT = gql`
	fragment stockDeliveryItem on StockDeliveryItem {
		id
		stockDelivery {
			id
		}
		product
		sourceWarehouseProduct {
			id
		}
		destinationWarehouseProduct {
			id
		} 
		receivedAt
		deliveredAt
		expiryCaptureRequired
		expiryPolicyContext
		expiryCapturedAt
		expiryBatches {
			id
			quantityOnHand
			expiryDate
			receivedAt
			expiryDateSource
			status
		}
	}
`;

export const GET_STOCK_DELIVERY_ITEM = gql`
	query($id: String) {
		getStockDeliveryItem (id: $id) {
			...stockDeliveryItem
		}
	}
	${STOCK_DELIVERY_ITEM_DETAIL_FRAGMENT}
`;
